import { render, staticRenderFns } from "./view-license-agreement.vue?vue&type=template&id=41065e9c&scoped=true&"
import script from "./view-license-agreement.vue?vue&type=script&lang=js&"
export * from "./view-license-agreement.vue?vue&type=script&lang=js&"
import style0 from "./view-license-agreement.vue?vue&type=style&index=0&id=41065e9c&scoped=true&lang=scss&"
import style1 from "./styles/add-edit-multi-consent.scss?vue&type=style&index=1&id=41065e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41065e9c",
  null
  
)

component.options.__file = "view-license-agreement.vue"
export default component.exports